<template>
    <div class="rules">
        <div class="title">
            <img class="slogan" src="@/assets/images_n/rules-title.png" alt="">
            <img class="vector" src="@/assets/images_n/rules-vector.png" alt="">
        </div>
        <div class="context">
            <label>活動時間：</label>
            <p>「蘇格登 – VIP限定 不管抽幾點，都要約一杯」活動（下稱「本活動」）自2022年6月17日開始，至2022年6月26日止。 </p>
            <label>活動說明：</label>
            <p>凡於活動期間內，加入「帝亞吉歐LINE官方帳號」並完成VIP綁定者即可參與本活動，完成指定步驟即有機會獲得LINE POINTS 5點、10點、20點、30點或50點，點數隨機贈送，兌完為止。</p>
            <label>活動步驟： </label>
            <p>步驟一、加入「帝亞吉歐LINE 官方帳號」。 </p>
            <p>步驟二、完成年齡驗證後，點擊「立即申請VIP」按鈕完成VIP申請；已加入者，完成「VIP綁定」即可參與活動；已是VIP者，即可直接參與活動。 </p>
            <p>步驟三、完成申請後，即可在選單點擊「不管抽幾點，都要約一杯」活動版位參與抽獎活動 。</p>
            <p>步驟四、首次開啟頁面者即獲得一次「刮刮卡」機會，隨機獲得LINE POINTS 0點、5點、10點、20點、30點或50點。於活動頁面使用分享功能，分享本活動給好友，若該好友透過分享連結首次成功加入帝亞吉歐LINE官方帳號，即可再獲得一次抽獎機會。 </p>
            <p>步驟五、若有抽中LINE POINTS點數，即可立即兌換。請留意，活動頁面將於 2022年6月27日00:00關閉，建議抽中後立即完成兌獎，避免錯過領獎機會。</p>
            <label>活動獎項： </label>
            <p>LINE POINTS 點數5點、10點、20點、30點和50點，點數隨機贈送，總計12,440份，數量有限，兌完為止，將不另行通知。</p>
            <label>活動主（承）辦單位： </label>
            <p>本活動主辦單位為巴拿馬商帝亞吉歐有限公司台灣分公司（DIAGEO TAIWAN INC., Taiwan Branch下稱「主辦單位」）。承辦單位為奧美廣告股份有限公司（下稱「承辦單位」）。 </p>
            <label>注意事項：</label>
            <p>1.	本活動僅開放給年滿十八歲之中華民國國民參加，但主辦單位、承辦單位及參與本活動相關單位（包含經銷商、分銷商、菸酒專賣店店家及員工與家屬）之員工及其二親等以內之血親及姻親親屬均不得參加。</p>
            <p>2.	參加者於參加本活動之同時，即明確瞭解主辦單位及承辦單位得因本活動之一切需要或消費者、客戶管理與服務、資（通）訊與資料庫管理、廣告或商業行為管理、調查、統計與研究分析、包括行銷、為履行法定或契約義務、保護當事人及相關利害關係人之權益、類似契約或其他法律關係事務、其他紛爭解決事件之處理、經營合於營業登記項目或組織章程所定之業務，以及為本活動及其相關事宜之進行（下稱蒐集目的），將參加者提供之姓名（含暱稱）、Facebook（或類似社群網站、通訊軟體等）暱稱、照片、聯絡電話、電子郵遞地址、地址、網路平臺申請之帳號（包括但不限於如Facebook或類似社群網站、通訊軟體等之帳號、暱稱、照片、性別、生日、朋友名單）、提供網路身分認證服務之紀錄、為完成收款或付款所需之資料、IP位址，以及其他為參與本活動所留存之得以直接或間接識別身分之個人資料，於上述蒐集目的範圍內，於主辦單位存續期間或至參加者請求刪除、停止處理或利用個人資料為止，供主辦單位、其台灣地區合作廠商及其所指定辦理本活動之委外廠商（包括但不限於代理商、合作廠商或其他企業、個人等），依個人資料保護相關法規蒐集、處理、利用。參加者得依個人資料保護法等相關法規，就其提供之個人資料，統一向承辦單位行使下列權利：(1)查詢、請求閱覽或請求製給複製本，而承辦單位依法得酌收必要成本；(2)請求補充或更正個人資料，惟依法需先適當釋明其原因及事實；(3)請求停止蒐集；(4)在個人資料正確性有爭議時，請求停止處理或利用本人之個人資料，惟主辦單位或承辦單位因執行職務或業務所須或本人書面同意並註明其爭議時不在此限；(5)於上述蒐集之特定目的消失或期限屆滿時，請求刪除、停止處理或利用本人之個人資料，惟主辦單位或承辦單位因依法應盡之義務或執行職務或業務所須或經本人書面同意者不在此限。參加者得自由選擇是否提供完整資料，若選擇不提供個人資料、或提供之個人資料不完全或不正確、或請求刪除或停止蒐集、處理、利用與國際傳輸其個人資料者，將喪失本活動之參加資格。有關個人資料蒐集、處理、國際傳輸及利用之告知及同意事項，請詳細參閱隱私權及Cookie聲明 https://www.diageotwcsr.com/privacy.php。</p>
            <p>3.	參加者保證所有提出之資料均為真實且正確，主辦單位及承辦單位有審核參加者資格之權利，並保留同意參加者參與本活動或提供相關服務與否之權利。若有偽造個人資料、冒用他人身分、散布違反善良風俗之影像、侵害他人權利(包括但不限於智慧財產權、人格權、肖像權及隱私權等)，或其他不符合本活動辦法或注意事項者，得取消其參加資格並移除相關內容；若有造成主辦單位或承辦單位之損害，參加者應負擔相關法律責任。</p>
            <p>4.	參加者應擔保其對於所提供本活動照片、資訊、留言、圖片、作品等(下稱參加內容)擁有合法之權利(包括但不限於著作權、肖像等人格權)，絕無侵害他人智慧財產權或其他權利之情事，並同意將參加內容無償授權主辦單位或承辦單位使用(包括但不限於編輯、重製、公開展示、散佈、電視廣告、平面廣告、戶外廣告、網路廣告等)。參加者違反其同意暨擔保內容者，主辦單位或承辦單位得取消參加資格，相關法律責任由參加者自行負責，如因此致主辦單位或承辦單位受損害者，應負賠償責任(包括但不限於所支出之律師費、訴訟費)。</p>
            <p>5.	參加者如因參加本活動而遭受任何損失，主辦單位或承辦單位不負任何責任。</p>
            <p>6.	參加者應依主辦單位或承辦單位之聯繫或公告之時程完成兌換申請，若未能及時完成兌換者，將可能影響活動參與、取得獎品、贈品或兌換品。如有任何因電腦、網路、電話、技術而不可歸責於主辦單位或承辦單位之事由，使寄予參加者之資料、獎品、贈品或兌換品有延遲、遺失、錯誤、無法辨識或毀損之情況，主辦單位及承辦單位不負任何法律責任。</p>
            <p>7.	參加者不得將參加、中獎、兌換或取得贈品之資格轉讓，亦不得要求折換為現金或轉換其他等值商品或有價證券，主辦單位保有更換等值獎品、贈品或兌換品之權利。 </p>
            <p>8.	本活動屬於機會中獎，依中華民國稅法規定，獎項價值新台幣1,001元（含）以上者（含累計），中獎者需繳交身分證影本供報稅使用，並於次年自行列入本年度之個人綜合所得稅申報，協辦機構將不再另外寄發紙本中獎所得扣繳憑單。獎項價值超過新台幣20,000元者（含累計），中獎者依法需預先扣繳10%機會中獎稅金，由本公司代扣。中獎者若非中華民國境內居住之個人（即在中華民國境內居住未達183天之本國人及外國人），不論獎項價值，皆須就中獎所得預先扣繳20%機會中獎稅金。中獎者若不願意配合或提供相關資料，則視為自動棄權中獎資格。中獎者同意依中華民國相關稅法規定繳納稅捐，並同意協辦單位奧美廣告股份有限公司依相關法令代扣（繳納）相關稅捐。</p>
            <p>9.	主辦單位保有以公告方式隨時解釋、補充、修改、變更本活動辦法及注意事項之權利，並有權決定取消、終止、或暫停本活動。補充、修改、變更後之相關內容將公佈於主辦單位及/或承辦單位網站及/或本活動相關應用程式（APP）上，不另行個別通知；參加者應隨時於前述網站（及/或本活動相關應用程式）上詳閱最新版本之本活動辦法與注意事項，且參加者瞭解並同意接受該等補充、修改或變更。活動內容若發生任何爭議概以主辦單位最後決定為準。</p>
            <p>10.	本活動之說明構成注意事項的一部分而具有法律約束力，參加者於參加本活動之同時，即表示已詳閱、瞭解及同意本活動辦法及注意事項與個人資料保護及隱私政策等相關規定，並同意遵守主辦單位及承辦單位的使用規範或其他交易有關之規定，如有違反，主辦單位或承辦單位有權取消其參加資格，並就因此所生之損害，向參加者請求損害賠償。如參加者不同意本活動辦法或注意事項之全部或部分內容，請勿參與本活動。</p>
            <p>禁止酒駕，未滿18歲禁止飲酒</p>
        </div>
        <div class="actions">
            <img src="@/assets/images_n/rules-vector.png" alt="">
            <div class="input" v-if="!checked">
                <input type="checkbox" name="readed" v-model="agreeInput">
                <label for="readed">已詳閱並同意活動辦法與規定</label>
            </div>
            <div class="button">
                <a v-if="!checked" @click="next()"><img src="@/assets/images_n/參加抽獎.png" alt=""></a>
                <router-link to="/" v-else>
                    <img src="@/assets/images_n/回首頁.png" alt="">
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  name: 'Rules',
  data(){
      return {
          agreeInput: false
      }
  },
  computed:{
      checked(){
          return this.$route.params.checked>0; 
      }
  },
  methods:{
      next(){
          let me = this;
          if(!this.agreeInput){
             Swal.fire('','提醒: 須同意活動辦法與規定才可參加此活動哦!');
          }else{
            this.$store.dispatch('agreeTerms').then(result => {
                if (result.data && result.data.msg === 'success') {
                    this.$store.dispatch('getPrize').then(result=>{
                        this.$store.commit('SET_LOADING', false);
                        if (result.data && result.data.msg === 'success' && result.data.data.status) {
                            this.$router.push({
                                name:'Gaming',
                                query:{
                                    value: result.data.data.awards,
                                    url: result.data.data.code
                                }
                            });
                        }
                    }).catch(err => {
                        if (err.response && err.response.data && err.response.data.msg === 'no quota') {
                        Swal.fire('','抽獎機會已使⽤完畢<br>邀請不同好友加入<br>可享更多抽獎機會！').then(()=>{
                            me.$router.push('/');
                        });
                        }
                    });
                } else {
                    this.$store.commit('SET_LOADING', false);
                    Swal.fire('','讀取資料發生錯誤，請重新整理後再試！');
                }
            }).catch(err => {
                this.$store.commit('SET_LOADING', false);
                Swal.fire('','讀取資料發生錯誤，請重新整理後再試！');
                return err;
            });
          }
      }
  }
}
</script>

<style lang="sass" scoped>
    .rules
        height: 100%
        display: flex
        flex-direction: column
        position: absolute
        top: 0
        left: 0
        width: 100%
        padding: 3.61vh 5%
        box-sizing: border-box
        &::after
            content: " "
            width: calc(100% - 1em)
            height: calc(100% - 1em)
            margin: .5em
            border-radius: 20px
            display: block
            position: absolute
            top: 0
            left: 0
            pointer-events: none
        .title
            img 
                width: 100%
                &.vector
                    margin-top: .5em
                    margin-bottom: 1em
        .context
            position: relative
            flex: 1
            color: #ffffff
            overflow-y: auto
            word-break: break-all
            text-align: justify
            width: 100%
            box-sizing: border-box
            label
                color: rgb(251, 195, 79)
            em
                font-style: normal
                font-weight: bold
                text-decoration: underline
            ol
                padding: 0 0 0 1em
                li
                    margin-top: 1em
            a
                color: #ffffff
                word-break: break-all
        .actions
            display: flex
            flex-direction: column
            padding-top: 1em
            align-items: center 
            position: relative
            > img 
                width: 100%
                margin-bottom: 1em
            .input
                display: flex
                justify-content: center
                align-items: center
                margin-bottom: 2.29vh
                input
                    margin-right: .5em
                    position: relative
                    z-index: 1
                label
                    color: rgb(223, 167, 96)
                    letter-spacing: 1px
                    position: relative
                    z-index: 1
            .button
                display: flex
                justify-content: center
                a
                    width: 100%
                    text-align: center
                    img
                        height: 5.32vh
                        position: relative
                        z-index: 1
</style>